<template>
  <RDModal class="filter-modal" ref="modal">
    <template v-slot:header>
      <div class="filter-modal__header">
        <div class="filter-modal__secondary-action">
          <span
            v-if="privates.filter.hasAnySelection(isFirstRoom)"
            class="filter-modal__clear"
            @click="onClearFilter"
            >{{ translate('rdClearAllFilters') }}</span
          >
        </div>
        <div class="filter-modal__title">
          {{ translate('rdFilters') }}
        </div>
        <div class="filter-modal__close">
          <button type="button" class="filter-modal__close-button" @click="$refs.modal.close()">
            <i class="icon-cross xs icon-right mt-1 text-black-50" />
          </button>
        </div>
      </div>
    </template>
    <template v-slot:content>
      <div class="d-flex flex-column">
        <span class="filter-modal__subtitle">{{ translate('rdCustomYourRates') }}</span>
        <FilterOptionMobileComponent
          v-for="(option, index) in filterOptions"
          :key="index"
          :option="option"
          :showNumberOfMatches="true"
          @select="onSelectFilter"
          @unselect="onUnselectFilter"
          :selectedRoomCode="selectedRoomCode"
          :numberOfRoomsLeftByRoomId="numberOfRoomsLeftByRoomId"
        />
      </div>
    </template>
    <template v-slot:footer>
      <button type="button" class="filter-modal__accept" @click="onAccept">
        {{ translate('rdFilterSave') }}
      </button>
    </template>
  </RDModal>
</template>

<script>
import RDModal from './RDModal'
import Filter from '../../domain/Filter'
import FilterOption from '../../domain/FilterOption'
import FilterOptionMobileComponent from '../filter/FilterOptionMobileComponent'
import Hotel from '../../domain/Hotel'
import Customer from '../../../domain/Customer'

export default {
  name: 'FilterModal',
  components: { FilterOptionMobileComponent, RDModal },
  data: () => ({
    privates: {
      filter: null
    }
  }),
  props: {
    customer: {
      customer: Customer
    },
    filter: {
      type: Filter
    },
    hotel: {
      type: Hotel
    },
    isFirstRoom: {
      type: Boolean,
      defaultValue: false
    },
    showBreakfast: {
      type: Boolean,
      defaultValue: false
    },
    selectedRoomCode: {
      type: String
    },
    numberOfRoomsLeftByRoomId: {
      type: Array
    }
  },
  computed: {
    filterOptions() {
      if (this.showBreakfast) {
        return this.privates.filter.options.filter(
          option => option.code !== FilterOption.MULTIROOM_ID
        )
      } else {
        return this.privates.filter.options.filter(
          option =>
            option.code !== FilterOption.MULTIROOM_ID && option.code !== FilterOption.BREAKFAST
        )
      }
    }
  },
  methods: {
    open() {
      const filter = this.filter.clone()
      const { recalculatedFilter } = this.hotel.applyFilter(filter, this.customer.isLogged)
      this.privates.filter = recalculatedFilter
      this.$refs.modal.open()
    },
    onSelectFilter(option) {
      const filter = this.privates.filter.select(option)
      const { recalculatedFilter } = this.hotel.applyFilter(filter, this.customer.isLogged)
      this.privates.filter = recalculatedFilter
    },
    onUnselectFilter(option) {
      const filter = this.privates.filter.unselect(option)
      const { recalculatedFilter } = this.hotel.applyFilter(filter, this.customer.isLogged)
      this.privates.filter = recalculatedFilter
    },
    onClearFilter() {
      const filter = this.privates.filter.reset()
      const { recalculatedFilter } = this.hotel.applyFilter(filter, this.customer.isLogged)
      this.privates.filter = recalculatedFilter
    },
    onAccept() {
      this.$refs.modal.close()
      this.$emit('accept', this.privates.filter)
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-modal {
  &__header {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    height: 100%;
  }
  &__secondary-action {
    padding-left: 3rem;
    width: 33%;
    text-align: left;
  }
  &__clear {
    cursor: pointer;
    font-weight: bold;
    text-decoration: underline;
    color: #c41c0f;
    font-size: 12px;
  }
  &__title {
    width: 33%;
    text-align: center;
    font-size: 16px;
  }
  &__close {
    width: 33%;
    text-align: end;
  }
  &__close-button {
    border: none;
    margin-inline-end: 1rem;
    background-color: transparent;
  }
  &__subtitle {
    padding: 2rem 3rem 1rem 3rem;
    width: 100%;
    text-align: start;
    font-size: 14px;
  }
  &__accept {
    width: 100%;
    height: 100%;
    color: white;
    background: #c00d0d;
    font-weight: 500;
    font-size: 14px;
    border: 0;
  }
}
</style>
